module.exports = __webpack_public_path__ + "img/bullet_ic.0ac99ed8.svg";